import Route from 'cio/routes/base';
import SqlImportsImportQueryController from 'cio/pods/sql-imports/import/query/controller';
import Transition from '@ember/routing/-private/transition';
import { action } from '@ember/object';
import SqlImportModel from 'cio/models/sql-import';

export default class SqlImportsImportQuery extends Route {
  resetController(controller: SqlImportsImportQueryController, isExiting: boolean, transition: Transition) {
    super.resetController(controller, isExiting, transition);
    controller.setDefaults();
    controller.resetModel();
  }

  @action
  willTransition(transition: Transition): void {
    let { model } = this.controller;
    if ('query' in (model as SqlImportModel).changedAttributes()) {
      transition.abort();
      (this.controller as SqlImportsImportQueryController).confirmTransition(transition);
    }
  }
}
